export default "__VITE_ASSET__DJVVDSri__"